module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "untitled-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-111"
    }
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#toc-anchor"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#toc-anchor-1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#toc-anchor-11"
    }
  }, [_vm._v("The Washington Murders")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_02#toc-anchor-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_02#toc-anchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Expanding Evil: 1974 - 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_03#toc-anchor-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_03#toc-anchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Killing Grounds: 1975")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_04#toc-anchor-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_04#toc-anchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unmasking")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#toc-anchor-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#toc-anchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to the End")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#toc-anchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#toc-anchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oddities and Insights")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#toc-anchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#toc-anchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bundy: A Man of Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#toc-anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#toc-anchor-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments#toc-anchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/about#toc-anchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45546686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 72
// module chunks = 0